import { useContactChannelsContext as z } from './contact-channels14.js';
import { attempt as o } from './contact-channels49.js';
import { useQuery as m } from './contact-channels37.js';
import { getAvailableCountries as n } from './contact-channels59.js';
import { useTranslations as $ } from './contact-channels38.js';
import { sortActiveCountries as a } from './contact-channels143.js';

const I=i=>{const{customData:t,segment:r="Regular"}=i||{},{locale:e,tenant:o$1}=z(),{t:a$1}=$();return m({queryKey:["c2c-countries",e,o$1,r,t],queryFn:async()=>{var n$1;if(t)return t;const{data:u,error:c}=await o(n(o$1,e,r));if(c)return [];const m=(n$1=u.message)==null?void 0:n$1.map(s=>({code:s,name:a$1(`countries.${s}`)}));return a(m,e)},staleTime:1/0,gcTime:1/0})};

export { I as useAvailableCountries };
//# sourceMappingURL=contact-channels80.js.map
